import { StateController } from "@aceroll/core";

class RoundFailController extends StateController {
    constructor() {
        super("round.fail");
    }
    async onStart() {
        const { slotMachine } = dispatcher.app.layout;
        await slotMachine.forceStop();

        this.stop();

    }
    onStop() { }
}

export default RoundFailController;